import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { StorySections } from '../components/StorySections';
import { QualificationSection } from '../components/QualificationSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { FAQGuaranteeSection } from '../components/FAQGuaranteeSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-bbq-dark font-sans text-gray-200 selection:bg-bbq-ember selection:text-white" data-id="element-294">
      <UrgencyBar data-id="element-295" />
      <main data-id="element-296">
        <HeroSection data-id="element-297" />
        <StorySections data-id="element-298" />
        <QualificationSection data-id="element-299" />
        <TestimonialsSection data-id="element-300" />
        <OfferSection data-id="element-301" />
        <PricingSection data-id="element-302" />
        <FAQGuaranteeSection data-id="element-303" />
        <ClosingSection data-id="element-304" />
      </main>
      <Footer data-id="element-305" />
      <RecentPurchaseToast data-id="element-306" />
    </div>;
}